import { render, staticRenderFns } from "./PointGaugeParts.vue?vue&type=template&id=adff6e28&scoped=true"
import script from "./PointGaugeParts.vue?vue&type=script&lang=ts"
export * from "./PointGaugeParts.vue?vue&type=script&lang=ts"
import style0 from "./PointGaugeParts.vue?vue&type=style&index=0&id=adff6e28&prod&lang=scss&scoped=true"
import style1 from "./PointGaugeParts.vue?vue&type=style&index=1&id=adff6e28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adff6e28",
  null
  
)

export default component.exports